import "./App.css";
import { useState } from "react";
import { useRef } from "react";

import Trump from "./media/trump-min.png";
import Status from "./media/status-alt.png";
import ReportBtn from "./media/report-btn.png";

// import ContractBg from "./media/contract-bg.png";
import csBg from "./media/contract-social-background.png";

import CopyBtn from "./media/copy-btn.png";

import XIcon from "./media/X.png";
import TelegramIcon from "./media/telegram.png";
import PumpIcon from "./media/pump-fun.png";
import DexIcon from "./media/dexscreener.png";
import BirdEyeIcon from "./media/birdeye.png";

import MissionBrief from "./media/mission-brief-alt.png";
import MissionProgress from "./media/mission-progress-alt.png";

import TodayOrderDesktop from "./media/today-order-desktop.png";
import TodayOrderMobile from "./media/today-order-mob.png";

import FooterBg from "./media/footer-bg.png";

const contractAddress =
  "AJVE7AxbuzStgv9S5cHaZQzwYGz8RLDA9xHe1ANuDtNc";

const displayContract = "AJVE7...DtNc";


function App() {
  const toastRef = useRef(null);

  // const copyContract = async () => {
  //   try {
  //     await navigator.clipboard.writeText(contractAddress);

  //     const toast = new window.bootstrap.Toast(
  //       toastRef.current
  //     );

  //     toast.show();

  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const copyContract = async () => {
    try {

      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(contractAddress);
      } else {
        const textArea = document.createElement("textarea");

        textArea.value = contractAddress;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";

        document.body.appendChild(textArea);

        textArea.focus();
        textArea.select();

        document.execCommand("copy");

        textArea.remove();
      }

      const toast = new window.bootstrap.Toast(
        toastRef.current
      );

      toast.show();

    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  return (
    <>
      {/* Hero Section */}

      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center hero-row">

            <div className="col-lg-4">
              <div className="hero-trump">
                <img
                  src={Trump}
                  alt="Private Trump"
                  className="img-fluid"
                />
              </div>
            </div>

            <div className="col-lg-4">
              <div className="hero-content">

                <h1 className="hero-title">
                  PRIVATE
                  <span>TRUMP</span>
                </h1>

                <div className="hero-divider">
                  <span></span>
                  ★ ★ ★
                  <span></span>
                </div>

                <p className="hero-subtitle">
                  FRESH OUT OF BOOT CAMP.
                  <br />
                  MISSION: SURVIVE.
                </p>

                <a href="https://jup.ag/swap?sell=So11111111111111111111111111111111111111112&buy=AJVE7AxbuzStgv9S5cHaZQzwYGz8RLDA9xHe1ANuDtNc" target="_blank" rel="noopener noreferrer">
                  <img
                    src={ReportBtn}
                    alt="Report For Duty"
                    className="img-fluid report-btn"
                  />
                </a>

              </div>
            </div>

            <div className="col-lg-4">
              <div className="hero-status">
                <img
                  src={Status}
                  alt="Military Status"
                  className="img-fluid"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Contract Section */}

      <section className="contract-section">
        <div className="container">

          <div className="contract-wrapper" style={{ backgroundImage: `url(${csBg})` }}>

            <div className="row g-0 align-items-center">

              <div className="col-lg-5">

                <div
                  className="contract-box text-center"

                >
                  <h3 className="contract-title">
                    CONTRACT
                  </h3>

                  <div className="contract-address">
                    {displayContract}
                  </div>

                  <div className="copy-btn-wrap text-center">

                    <img
                      src={CopyBtn}
                      alt="Copy Contract"
                      className="copy-btn-img"
                      onClick={copyContract}
                      onTouchStart={copyContract}
                    />

                  </div>

                </div>

              </div>

              <div className="col-lg-7">

                <div
                  className="sns-box"

                >

                  <div className="row text-center g-4 w-100">

                    <div className="col">
                      <a
                        href="https://x.com/PVTTRUMP"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={XIcon} alt="Twitter" />
                        <span>X (Twitter)</span>
                      </a>
                    </div>

                    <div className="col">
                      <a
                        href="https://t.me/privatetrumpHQ"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={TelegramIcon} alt="Telegram" />
                        <span>TELEGRAM</span>
                      </a>
                    </div>

                    <div className="col">
                      <a
                        href="https://pump.fun/coin/AJVE7AxbuzStgv9S5cHaZQzwYGz8RLDA9xHe1ANuDtNc"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={PumpIcon} alt="Pump Fun" />
                        <span>PUMP.FUN</span>
                      </a>
                    </div>

                    <div className="col">
                      <a
                        href="https://dexscreener.com/solana/wosgn7mxpwjlg23k5ytf82udewrn5mjgrxsharefygq"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={DexIcon} alt="Dexscreener" />
                        <span>DEXSCREENER</span>
                      </a>
                    </div>

                    <div className="col">
                      <a
                        href="https://birdeye.so/solana/token/AJVE7AxbuzStgv9S5cHaZQzwYGz8RLDA9xHe1ANuDtNc"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img src={BirdEyeIcon} alt="Birdeye" />
                        <span>BIRDEYE</span>
                      </a>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>
      </section>

      <section className="mission-section">
        <div className="container">

          <div className="row g-4 align-items-stretch">

            <div className="col-lg-5 d-flex">
              <div className="mission-card mission-brief w-100">
                <img
                  src={MissionBrief}
                  alt="Mission Brief"
                  className="img-fluid mission-img"
                />
              </div>
            </div>

            <div className="col-lg-7 d-flex">
              <div className="mission-card mission-progress w-100">
                <img
                  src={MissionProgress}
                  alt="Mission Progress"
                  className="img-fluid mission-img"
                />
              </div>
            </div>

          </div>

        </div>
      </section>

      <section className="orders-section">
        <div className="container">

          <div className="orders-wrapper">

            {/* Desktop */}

            <div className="d-none d-md-block text-center">
              <a href="https://jup.ag/swap?sell=So11111111111111111111111111111111111111112&buy=AJVE7AxbuzStgv9S5cHaZQzwYGz8RLDA9xHe1ANuDtNc" target="_blank" rel="noopener noreferrer">
              <img
                src={TodayOrderDesktop}
                alt="Today's Orders"
                className="img-fluid orders-img"
              />
              </a>
            </div>

            {/* Mobile */}

            <div className="d-block d-md-none text-center">
             <a href="https://jup.ag/swap?sell=So11111111111111111111111111111111111111112&buy=AJVE7AxbuzStgv9S5cHaZQzwYGz8RLDA9xHe1ANuDtNc" target="_blank" rel="noopener noreferrer">
             
              <img
                src={TodayOrderMobile}
                alt="Today's Orders"
                className="img-fluid orders-img-mobile"
              />

             </a>
            </div>

          </div>

        </div>
      </section>

      <section className="footer-section">
        <div className="container-fluid p-0">

          <div
            className="footer-box"
            style={{
              backgroundImage: `url(${FooterBg})`,
            }}
          >
            <div className="footer-tagline">
              <span></span>
              NO ROADMAP. NO PROMISES. ONLY SURVIVAL.
              <span></span>
            </div>

            <div className="footer-badge">
              ★ ★ <span>PVT</span> ★ ★
            </div>

            <div className="footer-copyright">
              © 2026 PRIVATE TRUMP
            </div>
            <div className="email"><a href="mailto:pvt@privatetrump.wtf">pvt@privatetrump.wtf</a></div>
          </div>

        </div>
      </section>

      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div
          ref={toastRef}
          className="toast align-items-center text-bg-dark border-0"
          role="alert"
        >
          <div className="d-flex">
            <div className="toast-body">
              Contract copied successfully!
            </div>

            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              data-bs-dismiss="toast"
            ></button>
          </div>
        </div>
      </div>

    </>
  );
}

export default App;